<section class="container-background container-fluid content">
  @if (logement$ | async; as logement) {
    <div class="row mb-4">
      <div class="col-12">
        <app-cover [title]="logement.nom"
          [subtitle]="getCoverSubtitle(logement)"
          [image]="logement.photo?.url ? (logement.photo.url | backResource) : 'assets-front/images/logement-default.jpg'">
        </app-cover>
      </div>
    </div>
    <div class="row">
      <div class="col-12 col-lg-3">
        @if (displayCorrespondantClient | async) {
          <div class="mb-4">
            <app-contact-card
              header='Mon contact {{logement?.correspondantClient?.societe?.raisonSociale}}'
              [photo]="logement.societe?.logo ? logement.societe.logo.url : (logement.correspondantClient?.photo ? $safeNavigationMigration(logement.correspondantClient?.photo.url) : null)"
              [name]="logement.correspondantClient.prenom + ' ' + logement.correspondantClient.nom"
              job="{{[logement.correspondantClient.fonction , logement.correspondantClient.ville] | join: ' - '}}"
              [phone]="logement.correspondantClient.telephone"
              [email]="logement.correspondantClient.adresseEmail"
              >
            </app-contact-card>
          </div>
        }
        <div class="mb-4">
          <app-offre-partenaire-card></app-offre-partenaire-card>
        </div>
      </div>
      <div class="col-12 col-lg-9">
        @if (conseilsAndActualites.length > 0) {
          <div class="card shadow mb-4">
            <div class="card-header color-blue">Actualités et conseils
              <button class="btn btn-blue btn-circle float-end" routerLink="/actualites">
                <fa-icon [icon]="faEye"></fa-icon>
              </button>
            </div>
            <div class="card-body">
              <swiper-container class="carousel-cards" [breakpoints]="carouselBreakpoints" [navigation]="conseilsAndActualites.length > 1" loop="true" space-between="16">
                @for (publication of conseilsAndActualites; track publication) {
                  <swiper-slide>
                    @if (isActualite(publication); as actualite) {
                      <app-card [link]="'/actualites/' + actualite.type + '/' + actualite.id" [title]="actualite.date | date:'dd/MM/y'"
                        [text]="actualite.titre"
                        [image]="actualite.images[0] ? (actualite.images[0].url | backResource) : ''">
                      </app-card>
                    }
                    @if (isConseil(publication); as conseil) {
                      <app-card [link]="'/conseils/' + conseil.id" [title]="conseil.date | date:'dd/MM/y'"
                        [text]="conseil.titre"
                        [image]="conseil.image ? (conseil.image.url | backResource) : ''">
                      </app-card>
                    }
                  </swiper-slide>
                }
              </swiper-container>
            </div>
          </div>
        }
        @if (carnetEquipements$ | async; as carnetEquipements) {
          @if (carnetEquipements.length > 0) {
            <div class="card shadow mb-4">
              <div class="card-header color-blue">Equipements
                <button class="btn btn-blue btn-circle float-end" routerLink="/mes-equipements">
                  <fa-icon [icon]="faEye"></fa-icon>
                </button>
              </div>
              <div class="card-body">
                <swiper-container class="carousel-cards" [breakpoints]="carouselBreakpoints" [navigation]="carnetEquipements.length > 1" loop="true" space-between="16">
                  @for (carnetEquipement of carnetEquipements; track carnetEquipement) {
                    <swiper-slide>
                      <app-card [link]="'/equipement/' + carnetEquipement.equipement.id" [image]="(carnetEquipement.equipement.image.url | backResource)"
                        [title]="carnetEquipement.equipement.nom" [text]="carnetEquipement.equipement.description | excerpt">
                      </app-card>
                    </swiper-slide>
                  }
                </swiper-container>
              </div>
            </div>
          }
        }
        @if (documents$ | async; as documents) {
          @if (documents.length > 0) {
            <div class="card shadow mb-4">
              <div class="card-header color-blue">Documents
                <button class="btn btn-blue btn-circle float-end" routerLink="/documents">
                  <fa-icon [icon]="faEye"></fa-icon>
                </button>
              </div>
              <div class="card-body">
                <swiper-container class="carousel-cards" [breakpoints]="carouselBreakpoints" [navigation]="documents.length > 1" loop="true" space-between="16">
                  @for (document of documents; track document) {
                    <swiper-slide>
                      <app-document-card [document]="document"></app-document-card>
                    </swiper-slide>
                  }
                </swiper-container>
              </div>
            </div>
          }
        }
      </div>
    </div>
  }
</section>
